<template>
    <div>
        <h2 class="ix-page-title-secondary mt-4">Contenu</h2>
        <div class="row mb-4">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                        <tr>
                            <th style="width: 30px;"></th>
                            <th style="width: 30px;">
                                <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                            </th>
                            <th style="width: 150px;">Référence</th>
                            <th>Désignation</th>
                            <th style="width: 120px;">Qté</th>
                            <th style="width: 120px;"></th>
                        </tr>
                        </thead>
                        <draggable v-model="deliveryLines" tag="tbody" handle=".handle-line" v-if="!loading">
                            <tr v-for="(deliveryLine, index) in deliveryLines" is="delivery-line-form"
                                v-bind:key="deliveryLine.uniq"
                                :delivery-line="deliveryLine"
                                :index="index"
                                :suggestionsRoute="suggestionsRoute"
                                :lineErrors="getLineErrors(index)"
                                v-on:line-editing-started="checkIfNewRowNeeded($event)"
                                v-on:line-deleted="deleteRow($event)"
                            ></tr>
                        </draggable>
                        <tr v-if="loading">
                            <td colspan="100%" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                    </table>
                </div>

                <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle ligne</button>
            </div>
        </div>
    </div>
</template>

<script>
    import DeliveryLineForm from "./DeliveryLineForm";
    import draggable from 'vuedraggable';

    export default {
        name: 'delivery-line-table-form',
        props: ['suggestionsRoute', 'oldDeliveryLines', 'lineErrors'],
        components : {
            DeliveryLineForm,
            draggable
        },
        data() {
            return {
                loading: true,
                deliveryLines: []
            };
        },
        provide() {
            return {
                // Un numéro ne sort qu'une fois : ceux d'un article déjà pris par les autres lignes de kit du BL.
                serialsTakenElsewhere: (articleId, deliveryLine) => {
                    return this.deliveryLines.filter(line => line !== deliveryLine).reduce((taken, line) => {
                        return taken.concat((line.serial_numbers || []).filter(sn => sn && parseInt(sn.article_id) === articleId).map(sn => sn.serial_number));
                    }, []);
                }
            };
        },
        methods : {
            addRow: function (line) {
                var data = {
                    id: null,
                    line_id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    unit: '',
                    has_serial_numbers: false,
                    serial_numbers: [],
                    // Composition d'un kit (quantité par kit), dépliable sous la désignation, jamais postée.
                    kit_components: [],
                    kit_open: false,
                    is_eco_participation: false,
                }

                if (line != null) {
                    data.id = line.id
                    data.line_id = line.line_id
                    data.is_title = line.is_title
                    data.reference = line.reference
                    data.designation = line.designation
                    data.description = line.description
                    data.quantity = line.quantity
                    data.unit = line.unit
                    data.has_serial_numbers = line.has_serial_numbers || false
                    data.serial_numbers = line.serial_numbers || []
                    data.kit_components = line.kit_components || []
                    data.is_eco_participation = line.is_eco_participation === true || line.is_eco_participation == 1
                }

                // Un kit garde le composant de chaque numéro ; un article, la seule valeur.
                var serialNumbers = line != null && line.serial_numbers ? Object.values(line.serial_numbers) : []
                if (data.kit_components.length > 0) {
                    data.serial_numbers = serialNumbers.filter(function(sn) {
                        return sn && sn.article_id && sn.serial_number
                    }).map(function(sn) {
                        return {serial_number: sn.serial_number, article_id: parseInt(sn.article_id)}
                    })
                } else if (serialNumbers.length > 0) {
                    data.serial_numbers = serialNumbers.map(function(sn) {
                        return sn.serial_number || sn
                    })
                    data.has_serial_numbers = true
                }

                this.deliveryLines.push(data)
            },
            deleteRow: function (index) {
                this.deliveryLines.splice(index, 1)
                if (this.deliveryLines.length == 0) {
                    this.addRow()
                }
            },
            checkIfNewRowNeeded: function (index) {
                if (this.deliveryLines.length > 0) {
                    if (this.deliveryLines.length - 1 == index) {
                        this.addRow()
                    }
                }
            },
            getLineErrors: function(index) {
                if (!this.lineErrors) return []
                var key = 'delivery_lines.' + index + '.serial_numbers'
                return this.lineErrors[key] || []
            },
            getLines: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(line => {
                        this.addRow(line)
                    })
                    this.addRow(null)
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            }
        },
        mounted(){
            const jsonLineBackup = JSON.parse(this.oldDeliveryLines)
            if (Array.isArray(jsonLineBackup)) {
                if (jsonLineBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonLineBackup.forEach(line => {
                        this.addRow(line)
                    })
                }
                this.loading = false
            } else {
                this.getLines(jsonLineBackup)
            }
        }
    }
</script>
